<script>
  import {_} from "svelte-i18n"
	import { createEventDispatcher } from "svelte"
  import { previews_are_google_fonts, google_fonts } from './../stores'
  import { fetchGoogleFonts } from './../modules/fontDetection'

  const dispatch = createEventDispatcher()

  function toggleGoogleFonts() {
    if (typeof $google_fonts === 'undefined') fetchGoogleFonts(storeGoogleFonts) 
    else dispatch('toggleGoogleFonts')
  }

  function storeGoogleFonts(data) {
    $google_fonts = data
    dispatch('toggleGoogleFonts')
  }

</script>

<span on:click={toggleGoogleFonts}>
	{#if $previews_are_google_fonts}
    {$_('navigation.backToYourFonts')}
	{:else}
    {$_('navigation.googleFonts')}
  {/if}
</span>